import React from "react";
import { makeStyles, useTheme } from "@material-ui/core";
import { CustomChip } from "./customChip";
import { PopperListRenderer } from "../hybridTypography/popperListRenderer";
import Skeleton from "@material-ui/lab/Skeleton";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles({
  root: {
    display: "flex",
    gap: 10,
    alignItems: "center",
    flexWrap: "wrap",
  },
});

export default function MultipleChip({ category, loading }) {
  const classes = useStyles();
  const theme = useTheme();
  const isBetween420And600 = useMediaQuery(theme.breakpoints.between(319, 600));
  const getCount = (data) =>{
      return data ? 1 : 2
  }
  const isBelow420And600 = useMediaQuery(theme.breakpoints.down(475));
  // const getWidth = (data) => {
  //   return data ? 143 : 200
  // }
  console.log(isBelow420And600)
  return (
    <>
    
      {loading && <Skeleton variant="text" width={120} />}
      {!loading && (
        <div className={classes.root}>
          {category?.slice(0, getCount(isBetween420And600))?.map((item) => (
            <CustomChip
              key={!!item?.value ? item?.value : item?.label}
              label={!!item?.label ? item?.label : "N/A"}
              // width = {getWidth(isBelow420And600)}
            />
          ))}
          {category?.length > getCount(isBetween420And600) && (
            <PopperListRenderer
              popperList={[...category.slice(2, category?.length)]?.map(
                (entity) => entity?.label
              )}
              count={category?.length - getCount(isBetween420And600)}
            />
          )}
        </div>
      )}
    </>
  );
}
